import classNames from 'classnames';
import React from 'react';

import Card from './Card';
import MarkdownText from '../MarkdownText';
import { toFullString } from '../../utils/date';

import './EmailThreadEntry.css';

const NAMES = {
  me: 'Andrew Hoyer',
  matt: 'Matt MacInnis',
}

const Email = ({ from, body, date }) => (
  <li className="EmailThreadEntry__email">
    <div className="EmailThreadEntry__email-head">
      <div
        className={classNames('EmailThreadEntry__email-avatar', {
          [`EmailThreadEntry__email-avatar--${from}`]: !!from,
        })}
      />
      <div className="EmailThreadEntry__email-name">{NAMES[from]}</div>
      <div className="EmailThreadEntry__email-date">{toFullString(date)}</div>
    </div>
    <div className="EmailThreadEntry__email-body">
      <MarkdownText text={body.trim()} />
    </div>
  </li>
);

export default ({ description, subject, thread }) => (
  <div className="EmailThreadEntry">
    <Card disablePadding>
      <div className="EmailThreadEntry__subject">Subject: {subject}</div>
      <ol className="EmailThreadEntry__thread">
        {thread.map((email, index) => <Email key={index} {...email} />)}
      </ol>
    </Card>
    <p className="EmailThreadEntry__description">{description}</p>
  </div>
);


// WEBPACK FOOTER //
// ./src/components/timeline/EmailThreadEntry.js